import type { AxiosError, AxiosInstance } from "axios";
import {
  dateTransformer,
  v2RequestSnakeCaseTransformer,
  v2ResponseCamelCaseTransformer,
} from "mws-utils";

type Params = {
  axios: AxiosInstance;
  createErrorFn: (options: {
    statusCode: number;
    statusMessage: string;
    message: string;
  }) => Error;
};

export const NOT_FOUND_MESSAGE = "404 page not found";

export function setUniversalAxiosInterceptors({
  axios,
  createErrorFn,
}: Params) {
  axios.defaults.transformResponse = [dateTransformer];
  axios.interceptors.request.use(v2RequestSnakeCaseTransformer);
  axios.interceptors.response.use(
    v2ResponseCamelCaseTransformer,
    (error: AxiosError) => {
      const err = error;
      if ("response" in err) {
        err.response = v2ResponseCamelCaseTransformer(err.response);
      }

      if (err.response?.status === 404) {
        throw createErrorFn({
          statusCode: 404,
          statusMessage: NOT_FOUND_MESSAGE,
          message: NOT_FOUND_MESSAGE,
        });
      }

      throw err;
    },
  );
}
